import type { FaireProductEntity } from "../../entity_types/product";

export const p_wj6eqc8rrn: FaireProductEntity = {
  token: "p_wj6eqc8rrn",
  type: "product",
  name: "Peanut Butter Cup Protein Bar",
  brandName: "Aloha",
  imageUrl:
    "https://cdn.faire.com/fastly/9a2a3ff4e60d8cf87201b8d3c3948dfe03fba893e2a80de9af2614b152efbe6f.jpeg",
  priceDollars: 26.38,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/203ce9845ff5329de92fc9be60297729580d427658bbe805fb4c8ed7748be5d4.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
